"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[16611],{

/***/ 982533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Api": function() { return /* reexport */ Api; },
  "ApiError": function() { return /* reexport */ ApiError; },
  "LOCALIZATION_KEY": function() { return /* reexport */ LOCALIZATION_KEY; },
  "PATTERN_VALIDATION": function() { return /* reexport */ PATTERN_VALIDATION; },
  "REGIONS": function() { return /* reexport */ REGIONS; },
  "RemoveProductListType": function() { return /* reexport */ RemoveProductListType; },
  "cartConfigPaths": function() { return /* reexport */ cartConfigPaths; },
  "cleanObject": function() { return /* reexport */ cleanObject; },
  "escapeString": function() { return /* reexport */ escapeString; },
  "formatCurrency": function() { return /* reexport */ formatCurrency; },
  "gachaGameAndFormPaths": function() { return /* reexport */ gachaGameAndFormPaths; },
  "getColorListFromContent": function() { return /* reexport */ getColorListFromContent; },
  "getCurrentLanguage": function() { return /* reexport */ getCurrentLanguage; },
  "getHttpLogger": function() { return /* reexport */ getHttpLogger; },
  "handlePasteSlug": function() { return /* reexport */ handlePasteSlug; },
  "isJsonString": function() { return /* reexport */ isJsonString; },
  "isValidEmailFormat": function() { return /* reexport */ isValidEmailFormat; },
  "isValidPhoneFormat": function() { return /* reexport */ isValidPhoneFormat; },
  "logger": function() { return /* reexport */ log_es_logger; },
  "orderPopupTags": function() { return /* reexport */ orderPopupTags; },
  "parseRuleRepeat": function() { return /* reexport */ parseRuleRepeat; },
  "performanceLogger": function() { return /* reexport */ performanceLogger; },
  "removeComponentFromPbConfigByTags": function() { return /* reexport */ removeComponentFromPbConfigByTags; },
  "resetGachaGameAndFormConfig": function() { return /* reexport */ resetGachaGameAndFormConfig; },
  "setCookie": function() { return /* reexport */ setCookie; },
  "setPbConfigProperties": function() { return /* reexport */ setPbConfigProperties; },
  "transformPbConfigData": function() { return /* reexport */ transformPbConfigData; },
  "unescapeString": function() { return /* reexport */ unescapeString; },
  "validateIsVisibleComponent": function() { return /* reexport */ validateIsVisibleComponent; }
});

;// CONCATENATED MODULE: ../../.yarn/cache/@tempi-utils-npm-1.6.1-UX4BUYER-8801.0-f3198828ff-72bb854ccc.zip/node_modules/@tempi/utils/dist/validators.es.js
const isValidEmailFormat = (email) => {
  const regex = /^.*@\w+\.\w+.*$/;
  return regex.test(email);
};
const isValidPhoneFormat = (number) => {
  if (!number.match(/^((09|03|07|08|05)+([0-9]{8}))$/) && !number.match(/^(\+(84)+(09|03|07|08|05)+([0-9]{8}))$/) && !number.match(/^(\+(84)+(9|3|7|8|5)+([0-9]{8}))$/) && !number.match(/^((84)+(09|03|07|08|05)+([0-9]{8}))$/) && !number.match(/^((84)+(9|3|7|8|5)+([0-9]{8}))$/)) {
    return false;
  }
  return true;
};
const domainNameRegex = /([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)/;
const PATTERN_VALIDATION = {
  basic: /^[a-zA-Z][a-zA-Z0-9_-]{2,50}$/,
  email: /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
  phone: /^(0|84|\+84)[1-9]([0-9]{8,9})$/,
  vietnameseName: /^[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹ\s\w|_]+$/,
  domain: new RegExp(
    `^(${domainNameRegex.source}|((?!www.)${domainNameRegex.source}{2,}))[a-z]{2,63}$`,
    "i"
  ),
  slug: /^[a-z0-9-]*$/i,
  taxCode: /^(\d{10}|\d{10}-\d{3})?$|^$/i,
  tempiLandingUrl: /^(https?:\/\/)?([a-zA-Z0-9.-]+(\.[a-zA-Z]{2,6}))+(:\d+)?(\/[a-z0-9-]*\/?){0,2}$/,
  color: /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{8})$|^rgb\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*\)$|^rgba\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*[0-1]\s*\)$/
};
const isJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};



;// CONCATENATED MODULE: ../../.yarn/cache/@tempi-utils-npm-1.6.1-UX4BUYER-8801.0-f3198828ff-72bb854ccc.zip/node_modules/@tempi/utils/dist/api/error.es.js
class ApiError {
  constructor(message, code, response) {
    this.message = message;
    this.response = response;
    this.code = code;
  }
  get reason() {
    return this.response;
  }
}



// EXTERNAL MODULE: ../../.yarn/cache/opentracing-npm-0.14.7-a8451c5ee8-5f7e444390.zip/node_modules/opentracing/lib/index.js
var lib = __webpack_require__(83492);
;// CONCATENATED MODULE: ../../.yarn/cache/@tempi-utils-npm-1.6.1-UX4BUYER-8801.0-f3198828ff-72bb854ccc.zip/node_modules/@tempi/utils/dist/api/index.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const normalizeSlashUrl = (baseURL = "", url) => {
  const normalizedBaseUrl = baseURL.endsWith("/") ? baseURL.slice(0, baseURL.length - 1) : baseURL;
  const normalizedPath = url.startsWith("/") ? url.slice(1) : url;
  return `${normalizedBaseUrl}/${normalizedPath}`;
};
const DEFAULT_ERROR_MESSAGE = "\u0110\xE3 c\xF3 l\u1ED7i x\u1EA3y ra, vui l\xF2ng th\u1EED l\u1EA1i sau!";
class Api {
  constructor(url, getError, defaultConfig = {}) {
    this.baseURL = url;
    this.interceptors = [];
    this.getError = getError;
    this.defaultConfig = defaultConfig;
  }
  _parseJson(response) {
    return response.text().then((text) => text ? JSON.parse(text) : null);
  }
  addInterceptor(interceptFn) {
    this.interceptors.push(interceptFn);
  }
  appendParamsToURL(url, params = {}) {
    if (params) {
      const paramsArr = [];
      for (const k of Object.keys(params)) {
        if (params[k] !== null && params[k] !== void 0) {
          paramsArr.push(`${k}=${encodeURIComponent(params[k])}`);
        }
      }
      if (paramsArr.length > 0)
        url = `${url}?${paramsArr.join("&")}`;
    }
    return url;
  }
  async request(path, body, method, config = {}) {
    var _a;
    const { params: configParams } = config;
    let headers = config.headers || {};
    const url = this.appendParamsToURL(path, configParams || {});
    let serializedBody = null;
    const isFormData = body && typeof body !== "string" && "append" in body;
    if (body) {
      if (typeof body !== "string") {
        if (isFormData) {
          serializedBody = new URLSearchParams(body).toString();
        } else {
          serializedBody = JSON.stringify(body);
          headers = __spreadValues({
            "Content-Type": "application/json"
          }, headers);
        }
      }
    }
    let serializedParams = null;
    if (configParams) {
      serializedParams = JSON.stringify(configParams);
    }
    const tracer = (0,lib.globalTracer)();
    const spanName = `[${method}] ${normalizeSlashUrl(this.baseURL, path)}`;
    const span = tracer.startSpan(spanName);
    tracer.inject(span, lib.FORMAT_HTTP_HEADERS, headers);
    span.setTag("http.method", method);
    span.setTag("http.baseurl", this.baseURL);
    span.log({
      body: serializedBody,
      params: serializedParams
    });
    const requestObj = __spreadProps(__spreadValues({}, this.defaultConfig), {
      method,
      headers: new Headers(headers),
      body: isFormData ? body : serializedBody
    });
    this.interceptors.forEach((fn) => fn(requestObj));
    const res = await fetch(
      url.startsWith("http") ? url : normalizeSlashUrl(this.baseURL, url),
      requestObj
    );
    if (res.status >= 400) {
      const resp = await res.json();
      const error = ((_a = this.getError) == null ? void 0 : _a.call(this, resp)) || new ApiError(DEFAULT_ERROR_MESSAGE, -1, resp);
      span.setTag("status", "error");
      span.log({
        error: JSON.stringify(error)
      });
      span.finish();
      return Promise.reject(error);
    }
    const respHeaders = {};
    res.headers.forEach((val, key) => respHeaders[key] = val);
    const data = await this._parseJson(res);
    span.setTag("status", "success");
    span.finish();
    return { code: res.status, data, headers: respHeaders };
  }
  async get(url, config = {}) {
    return await this.request(url, null, "GET", config);
  }
  async post(url, body, config = {}) {
    return await this.request(url, body, "POST", config);
  }
  async patch(url, body, config = {}) {
    return await this.request(url, body, "PATCH", config);
  }
  async put(url, body, config = {}) {
    return await this.request(url, body, "PUT", config);
  }
  async delete(url, body = {}, config = {}) {
    return await this.request(url, body, "DELETE", config);
  }
}



// EXTERNAL MODULE: ../../.yarn/cache/pino-npm-6.13.3-50e2aceb53-a580decd47.zip/node_modules/pino/browser.js
var browser = __webpack_require__(43238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ../../.yarn/cache/pino-http-npm-5.8.0-05607f4f37-1bb38dfa72.zip/node_modules/pino-http/logger.js
var logger = __webpack_require__(68110);
var logger_default = /*#__PURE__*/__webpack_require__.n(logger);
;// CONCATENATED MODULE: ../../.yarn/cache/@tempi-utils-npm-1.6.1-UX4BUYER-8801.0-f3198828ff-72bb854ccc.zip/node_modules/@tempi/utils/dist/log.es.js
/* provided dependency */ var process = __webpack_require__(273173);



const log_es_logger = browser_default()({
  prettyPrint: "production" === "development",
  level: process.env.LOG_LEVEL || "info",
  serializers: {
    err: (browser_default()).stdSerializers.err,
    req: (browser_default()).stdSerializers.req
  },
  browser: {
    transmit: {
      level: "error",
      send: (_level, logEvent) => {
        if (typeof window !== "undefined" && window.track) {
          window.track("error", {
            errorSource: "client",
            errorCode: "unknown",
            errorMessage: JSON.stringify(logEvent)
          });
        }
      }
    }
  }
});
const getHttpLogger = (opts) => {
  const { customProps } = opts || {};
  return logger_default()({
    logger: log_es_logger,
    customLogLevel: function(res, err) {
      if (res.statusCode >= 400 && res.statusCode < 500) {
        return "warn";
      } else if (res.statusCode >= 500 || err) {
        return "error";
      }
      return "debug";
    },
    autoLogging: true,
    customProps
  });
};



;// CONCATENATED MODULE: ../../.yarn/cache/@tempi-utils-npm-1.6.1-UX4BUYER-8801.0-f3198828ff-72bb854ccc.zip/node_modules/@tempi/utils/dist/text.es.js
const formatCurrency = (value, includeUnit = true, locale = "vi-VN", currency = "VND") => {
  if (typeof value !== "number")
    return null;
  let currencyFormat;
  if (includeUnit)
    currencyFormat = new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 10
    });
  else
    currencyFormat = new Intl.NumberFormat(locale);
  return currencyFormat.format(value);
};
const escapeString = (text) => {
  if (!text)
    return "";
  const map = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#039;"
  };
  return text.replace(/[&<>"']/g, function(m) {
    return map[m];
  });
};
const unescapeString = (text) => {
  if (!text)
    return "";
  const map = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#039;": "'"
  };
  return text.replace(/&amp;|&lt;|&gt;|&quot;|&#039;/g, function(m) {
    return map[m];
  });
};



;// CONCATENATED MODULE: ../../.yarn/cache/@tempi-utils-npm-1.6.1-UX4BUYER-8801.0-f3198828ff-72bb854ccc.zip/node_modules/@tempi/utils/dist/object.es.js
const cleanObject = (object) => {
  if (!object) {
    return object;
  }
  const newObj = {};
  const currentKeys = Object.keys(object);
  currentKeys.forEach((key) => {
    if (typeof object[key] !== "undefined") {
      newObj[key] = object[key];
    }
  });
  return newObj;
};



// EXTERNAL MODULE: ../../.yarn/cache/dayjs-npm-1.11.6-44daf311a9-18bdfd9270.zip/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(287268);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ../../.yarn/cache/@tempi-types-npm-1.6.1-UX4BUYER-8801.0-e3d85a5b4e-01f6471ce2.zip/node_modules/@tempi/types/dist/pb/interfaces.es.js
var LinkType = /* @__PURE__ */ ((LinkType2) => {
  LinkType2["inPage"] = "inPage";
  LinkType2["external"] = "external";
  LinkType2["email"] = "email";
  LinkType2["phone"] = "phone";
  LinkType2["internal"] = "internal";
  return LinkType2;
})(LinkType || {});
var Device = /* @__PURE__ */ ((Device2) => {
  Device2["DESKTOP"] = "desktop";
  Device2["MOBILE"] = "mobile";
  return Device2;
})(Device || {});
var PreviewDevice = /* @__PURE__ */ ((PreviewDevice2) => {
  PreviewDevice2["DESKTOP"] = "desktop";
  PreviewDevice2["MOBILE"] = "mobile";
  PreviewDevice2["TABLET"] = "tablet";
  return PreviewDevice2;
})(PreviewDevice || {});
var PageScanLogStatus = /* @__PURE__ */ ((PageScanLogStatus2) => {
  PageScanLogStatus2["PENDING"] = "pending";
  PageScanLogStatus2["DEACTIVATED"] = "deactivated";
  PageScanLogStatus2["IGNORED"] = "ignored";
  PageScanLogStatus2["SAFE"] = "safe";
  return PageScanLogStatus2;
})(PageScanLogStatus || {});
var Status = /* @__PURE__ */ ((Status2) => {
  Status2["DRAFT"] = "draft";
  Status2["PUBLISHED"] = "published";
  return Status2;
})(Status || {});
var DesignMode = /* @__PURE__ */ ((DesignMode2) => {
  DesignMode2["RESPONSIVE"] = "responsive";
  DesignMode2["MOBILE_ONLY"] = "mobile-only";
  DesignMode2["ADAPTIVE"] = "adaptive";
  return DesignMode2;
})(DesignMode || {});
var HostingPlatform = /* @__PURE__ */ ((HostingPlatform2) => {
  HostingPlatform2["TEKO"] = "Teko";
  HostingPlatform2["ERP"] = "Erp";
  HostingPlatform2["ADMIN"] = "Admin";
  return HostingPlatform2;
})(HostingPlatform || {});
var ActionAfterSubmit = /* @__PURE__ */ ((ActionAfterSubmit2) => {
  ActionAfterSubmit2["api"] = "api";
  ActionAfterSubmit2["sheet"] = "sheet";
  return ActionAfterSubmit2;
})(ActionAfterSubmit || {});
var OverlayType = /* @__PURE__ */ ((OverlayType2) => {
  OverlayType2["color"] = "color";
  OverlayType2["gradient"] = "gradient";
  return OverlayType2;
})(OverlayType || {});
var WidthTypeEnum = /* @__PURE__ */ ((WidthTypeEnum2) => {
  WidthTypeEnum2["auto"] = "auto";
  WidthTypeEnum2["full"] = "full";
  WidthTypeEnum2["fixed"] = "fixed";
  return WidthTypeEnum2;
})(WidthTypeEnum || {});
var SliderTypeEnum = /* @__PURE__ */ ((SliderTypeEnum2) => {
  SliderTypeEnum2["image"] = "image";
  SliderTypeEnum2["product"] = "product";
  return SliderTypeEnum2;
})(SliderTypeEnum || {});
var Position = /* @__PURE__ */ ((Position2) => {
  Position2["front"] = "front";
  Position2["behind"] = "behind";
  return Position2;
})(Position || {});
var UnitEnum = /* @__PURE__ */ ((UnitEnum2) => {
  UnitEnum2["percent"] = "%";
  UnitEnum2["pixel"] = "px";
  return UnitEnum2;
})(UnitEnum || {});
var TimeUnitEnum = /* @__PURE__ */ ((TimeUnitEnum2) => {
  TimeUnitEnum2["second"] = "s";
  return TimeUnitEnum2;
})(TimeUnitEnum || {});
var ColorType = /* @__PURE__ */ ((ColorType2) => {
  ColorType2["solid"] = "solid";
  ColorType2["gradient"] = "gradient";
  return ColorType2;
})(ColorType || {});
var GradientType = /* @__PURE__ */ ((GradientType2) => {
  GradientType2["linear"] = "linear";
  GradientType2["radial"] = "radial";
  return GradientType2;
})(GradientType || {});
var InputType = /* @__PURE__ */ ((InputType2) => {
  InputType2["text"] = "text";
  InputType2["number"] = "number";
  InputType2["email"] = "email";
  InputType2["textarea"] = "textarea";
  InputType2["phoneNumber"] = "phoneNumber";
  InputType2["radioGroup"] = "radioGroup";
  InputType2["checkboxGroup"] = "checkboxGroup";
  InputType2["select"] = "select";
  InputType2["dateTime"] = "dateTime";
  InputType2["hidden"] = "hidden";
  return InputType2;
})(InputType || {});
var ValueType = /* @__PURE__ */ ((ValueType2) => {
  ValueType2["string"] = "string";
  ValueType2["number"] = "number";
  ValueType2["boolean"] = "boolean";
  return ValueType2;
})(ValueType || {});
var DateTimeType = /* @__PURE__ */ ((DateTimeType2) => {
  DateTimeType2["date"] = "date";
  DateTimeType2["time"] = "time";
  DateTimeType2["datetime"] = "datetime";
  return DateTimeType2;
})(DateTimeType || {});
var CaptchaVersionEnum = /* @__PURE__ */ ((CaptchaVersionEnum2) => {
  CaptchaVersionEnum2["checkboxV2"] = "checkboxV2";
  CaptchaVersionEnum2["invisibleV2"] = "invisibleV2";
  CaptchaVersionEnum2["invisibleV3"] = "invisibleV3";
  return CaptchaVersionEnum2;
})(CaptchaVersionEnum || {});
var MenuItemType = /* @__PURE__ */ ((MenuItemType2) => {
  MenuItemType2["button"] = "button";
  MenuItemType2["link"] = "link";
  return MenuItemType2;
})(MenuItemType || {});
var PositionHeader = /* @__PURE__ */ ((PositionHeader2) => {
  PositionHeader2["NORMAL"] = "normal";
  PositionHeader2["STICKY"] = "sticky";
  PositionHeader2["DYNAMIC"] = "dynamic";
  return PositionHeader2;
})(PositionHeader || {});
var BuilderType = /* @__PURE__ */ ((BuilderType2) => {
  BuilderType2["BASIC"] = "Basic";
  BuilderType2["ADVANCED"] = "Advanced";
  return BuilderType2;
})(BuilderType || {});
var RepeatTypeEnum = /* @__PURE__ */ ((RepeatTypeEnum2) => {
  RepeatTypeEnum2["DAILY"] = "DAILY";
  RepeatTypeEnum2["DAY_IN_WEEK"] = "DAY_IN_WEEK";
  RepeatTypeEnum2["CUSTOM"] = "CUSTOM";
  RepeatTypeEnum2["NO_REPEAT"] = "NO_REPEAT";
  return RepeatTypeEnum2;
})(RepeatTypeEnum || {});
var UnitRepeatEnum = /* @__PURE__ */ ((UnitRepeatEnum2) => {
  UnitRepeatEnum2["DAY"] = "DAILY";
  UnitRepeatEnum2["WEEK"] = "WEEKLY";
  UnitRepeatEnum2["MONTH"] = "MONTH";
  UnitRepeatEnum2["YEAR"] = "YEAR";
  UnitRepeatEnum2["DURATION"] = "DURATION";
  return UnitRepeatEnum2;
})(UnitRepeatEnum || {});
var RuleRepeatEnum = /* @__PURE__ */ ((RuleRepeatEnum2) => {
  RuleRepeatEnum2["FREQ"] = "FREQ";
  RuleRepeatEnum2["INTERVAL"] = "INTERVAL";
  RuleRepeatEnum2["BYDAY"] = "BYDAY";
  RuleRepeatEnum2["UNTIL"] = "UNTIL";
  return RuleRepeatEnum2;
})(RuleRepeatEnum || {});
var FormAccountType = /* @__PURE__ */ ((FormAccountType2) => {
  FormAccountType2["GOOGLE_SHEET"] = "GOOGLE_SHEET";
  FormAccountType2["API"] = "API";
  FormAccountType2["GOOGLE_FORM"] = "GOOGLE_FORM";
  FormAccountType2["EMAIL"] = "EMAIL";
  return FormAccountType2;
})(FormAccountType || {});
var ApiMethod = /* @__PURE__ */ ((ApiMethod2) => {
  ApiMethod2["GET"] = "GET";
  ApiMethod2["POST"] = "POST";
  ApiMethod2["PATCH"] = "PATCH";
  return ApiMethod2;
})(ApiMethod || {});
var WebsiteLinkType = /* @__PURE__ */ ((WebsiteLinkType2) => {
  WebsiteLinkType2["PAGE"] = "PAGE";
  WebsiteLinkType2["LINK"] = "LINK";
  return WebsiteLinkType2;
})(WebsiteLinkType || {});
var TargetOpenPage = /* @__PURE__ */ ((TargetOpenPage2) => {
  TargetOpenPage2["SELF"] = "SELF";
  TargetOpenPage2["BLANK"] = "BLANK";
  return TargetOpenPage2;
})(TargetOpenPage || {});
var SourceComponentStatusEnum = /* @__PURE__ */ ((SourceComponentStatusEnum2) => {
  SourceComponentStatusEnum2["WAITING_FOR_DEPLOY"] = "WAITING_FOR_DEPLOY";
  SourceComponentStatusEnum2["DEPLOYING"] = "DEPLOYING";
  SourceComponentStatusEnum2["FAILED"] = "FAILED";
  SourceComponentStatusEnum2["AVAILABLE"] = "AVAILABLE";
  return SourceComponentStatusEnum2;
})(SourceComponentStatusEnum || {});
var DisplayStatus = /* @__PURE__ */ ((DisplayStatus2) => {
  DisplayStatus2["SHOW_WITH_ENDUSER"] = "show_with_enduser";
  DisplayStatus2["HIDDEN_WITH_ENDUSER"] = "hidden_with_enduser";
  return DisplayStatus2;
})(DisplayStatus || {});
var ToxicTypeEnum = /* @__PURE__ */ ((ToxicTypeEnum2) => {
  ToxicTypeEnum2["toxicBacklink"] = "toxic_backlink";
  return ToxicTypeEnum2;
})(ToxicTypeEnum || {});
var ActionsForToxicContent = /* @__PURE__ */ ((ActionsForToxicContent2) => {
  ActionsForToxicContent2["addNofollowToLink"] = "add_nofollow_to_link";
  return ActionsForToxicContent2;
})(ActionsForToxicContent || {});
var GachaGameType = /* @__PURE__ */ ((GachaGameType2) => {
  GachaGameType2[GachaGameType2["luckyDraw"] = 1] = "luckyDraw";
  GachaGameType2[GachaGameType2["treasureHunting"] = 2] = "treasureHunting";
  GachaGameType2[GachaGameType2["flipLuckyMoney"] = 3] = "flipLuckyMoney";
  GachaGameType2[GachaGameType2["potSmashing"] = 4] = "potSmashing";
  return GachaGameType2;
})(GachaGameType || {});
var FontSource = /* @__PURE__ */ ((FontSource2) => {
  FontSource2["GOOGLE"] = "google";
  FontSource2["TEMPI"] = "tempi";
  FontSource2["UNKNOWN"] = "unknown";
  return FontSource2;
})(FontSource || {});
var DomainUsageStatus = /* @__PURE__ */ ((DomainUsageStatus2) => {
  DomainUsageStatus2["USED"] = "USED";
  DomainUsageStatus2["USED_BY_LANDING"] = "USED_BY_LANDING";
  DomainUsageStatus2["USED_BY_WEBSITE"] = "USED_BY_WEBSITE";
  DomainUsageStatus2["UNUSED"] = "UNUSED";
  DomainUsageStatus2["UNUSED_BY_LANDING"] = "UNUSED_BY_LANDING";
  DomainUsageStatus2["UNUSED_BY_WEBSITE"] = "UNUSED_BY_WEBSITE";
  return DomainUsageStatus2;
})(DomainUsageStatus || {});
var WebsiteCompletenessChecklistKey = /* @__PURE__ */ ((WebsiteCompletenessChecklistKey2) => {
  WebsiteCompletenessChecklistKey2["DESIGN_WEBSITE"] = "design_website";
  WebsiteCompletenessChecklistKey2["ADD_FAVICON"] = "add_favicon";
  WebsiteCompletenessChecklistKey2["ADD_SOCIAL_MEDIA_IMAGES"] = "add_social_media_images";
  WebsiteCompletenessChecklistKey2["PUBLISH_WEBSITE"] = "publish_website";
  WebsiteCompletenessChecklistKey2["CONFIGURE_SEO"] = "configure_seo";
  return WebsiteCompletenessChecklistKey2;
})(WebsiteCompletenessChecklistKey || {});
var PageCompletenessChecklistKey = /* @__PURE__ */ ((PageCompletenessChecklistKey2) => {
  PageCompletenessChecklistKey2["DESIGN_PAGE"] = "design_page";
  PageCompletenessChecklistKey2["ADD_FAVICON_PAGE"] = "add_favicon_page";
  PageCompletenessChecklistKey2["ADD_SOCIAL_MEDIA_IMAGES_PAGE"] = "add_social_media_images_page";
  PageCompletenessChecklistKey2["PUBLISH_PAGE"] = "publish_page";
  PageCompletenessChecklistKey2["CONFIGURE_SEO_PAGE"] = "configure_seo_page";
  return PageCompletenessChecklistKey2;
})(PageCompletenessChecklistKey || {});
var OpenSettingModalTab = /* @__PURE__ */ ((OpenSettingModalTab2) => {
  OpenSettingModalTab2["SEO"] = "seo-tab";
  OpenSettingModalTab2["SOCIAL_MEDIA_IMAGE"] = "social-media-image-tab";
  return OpenSettingModalTab2;
})(OpenSettingModalTab || {});
var CalculateNumOfPlaysMethod = /* @__PURE__ */ ((CalculateNumOfPlaysMethod2) => {
  CalculateNumOfPlaysMethod2[CalculateNumOfPlaysMethod2["USER_COLLECTED"] = 2] = "USER_COLLECTED";
  CalculateNumOfPlaysMethod2[CalculateNumOfPlaysMethod2["GAME_CONDITION"] = 1] = "GAME_CONDITION";
  return CalculateNumOfPlaysMethod2;
})(CalculateNumOfPlaysMethod || {});
var ActionUpdateGameTurn = /* @__PURE__ */ ((ActionUpdateGameTurn2) => {
  ActionUpdateGameTurn2[ActionUpdateGameTurn2["INCREASE"] = 1] = "INCREASE";
  ActionUpdateGameTurn2[ActionUpdateGameTurn2["DECREASE"] = 2] = "DECREASE";
  ActionUpdateGameTurn2[ActionUpdateGameTurn2["RESET"] = 3] = "RESET";
  return ActionUpdateGameTurn2;
})(ActionUpdateGameTurn || {});
var WebsiteAdditionalFieldEnum = /* @__PURE__ */ ((WebsiteAdditionalFieldEnum2) => {
  WebsiteAdditionalFieldEnum2["THEME"] = "theme";
  WebsiteAdditionalFieldEnum2["COMPLETENESS_CHECKLIST"] = "completenessChecklist";
  return WebsiteAdditionalFieldEnum2;
})(WebsiteAdditionalFieldEnum || {});
var WebsiteTemplateAdditionalFieldEnum = /* @__PURE__ */ ((WebsiteTemplateAdditionalFieldEnum2) => {
  WebsiteTemplateAdditionalFieldEnum2["THEME"] = "theme";
  return WebsiteTemplateAdditionalFieldEnum2;
})(WebsiteTemplateAdditionalFieldEnum || {});



;// CONCATENATED MODULE: ../../.yarn/cache/@tempi-utils-npm-1.6.1-UX4BUYER-8801.0-f3198828ff-72bb854ccc.zip/node_modules/@tempi/utils/dist/helper.es.js



const formatDate = (date) => {
  if (!date)
    return void 0;
  return new Date(date).toISOString();
};
const parseRuleRepeat = (field, ruleRepeat) => {
  var _a;
  const regex = new RegExp(`(${field}:)[^;]+(?=;)`, "g");
  const result = ruleRepeat.match(regex);
  return (result == null ? void 0 : result.length) > 0 ? (_a = result[0]) == null ? void 0 : _a.replaceAll(`${field}:`, "") : void 0;
};
const validateIsVisibleComponent = ({
  startTime,
  endTime,
  ruleRepeat,
  date,
  duration
}) => {
  var _a;
  const now = new Date().toISOString();
  const formattedStartTime = formatDate(startTime);
  const formattedEndTime = formatDate(endTime);
  if (formattedStartTime && now < formattedStartTime) {
    return false;
  }
  if (formattedEndTime && now >= formattedEndTime) {
    return false;
  }
  if (ruleRepeat) {
    const interval = parseRuleRepeat(RuleRepeatEnum.INTERVAL, ruleRepeat) ? parseInt(parseRuleRepeat(RuleRepeatEnum.INTERVAL, ruleRepeat)) : 1;
    const freq = parseRuleRepeat(RuleRepeatEnum.FREQ, ruleRepeat);
    const until = parseRuleRepeat(RuleRepeatEnum.UNTIL, ruleRepeat);
    const byDay = parseRuleRepeat(RuleRepeatEnum.BYDAY, ruleRepeat);
    if (date && now < dayjs_min_default()(date).hour(0).minute(0).second(0).toISOString())
      return false;
    if (until && now > formatDate(until))
      return false;
    let isDateVisible = true;
    const isValidTime = (unit) => {
      if (interval === 1 && (unit === "day" || unit === "week"))
        return true;
      const dateDiff = date ? dayjs_min_default()(now).diff(date, unit) : -1;
      return dateDiff >= 0 && dateDiff % interval === 0;
    };
    switch (freq) {
      case UnitRepeatEnum.DAY:
        isDateVisible = isValidTime("day");
        break;
      case UnitRepeatEnum.WEEK:
        isDateVisible = isValidTime("week") && ((_a = byDay == null ? void 0 : byDay.split(",")) == null ? void 0 : _a.includes(dayjs_min_default()(now).day().toString()));
        break;
      case UnitRepeatEnum.MONTH:
        isDateVisible = isValidTime("month") && dayjs_min_default()(now).get("date") === dayjs_min_default()(date).get("date");
        break;
      case UnitRepeatEnum.YEAR:
        isDateVisible = isValidTime("year") && dayjs_min_default()(now).get("date") === dayjs_min_default()(date).get("date") && dayjs_min_default()(now).get("month") === dayjs_min_default()(date).get("month");
        break;
    }
    if (!isDateVisible)
      return false;
    if (duration && (duration[0] && dayjs_min_default()(now).hour() * 60 + dayjs_min_default()(now).minute() < duration[0] || duration[1] && dayjs_min_default()(now).hour() * 60 + dayjs_min_default()(now).minute() >= duration[1]))
      return false;
  }
  return true;
};
const gachaGameAndFormPaths = [
  {
    path: ["customAttributes", "luckydrawv2", "configStorage", "formConfigId"],
    tag: "luckydrawv2"
  },
  {
    path: ["elementId"],
    tag: "luckydrawv2"
  },
  {
    path: ["customAttributes", "luckydrawv2", "gameId"],
    tag: "luckydrawv2"
  },
  {
    path: ["customAttributes", "luckymoney", "gameId"],
    tag: "luckymoney"
  },
  {
    path: ["customAttributes", "luckymoney", "configStorage", "formConfigId"],
    tag: "luckymoney"
  },
  {
    path: ["customAttributes", "potsmashing", "configStorage", "formConfigId"],
    tag: "potsmashing"
  },
  {
    path: ["customAttributes", "potsmashing", "gameId"],
    tag: "potsmashing"
  },
  {
    path: [
      "customAttributes",
      "treasurehunting",
      "configStorage",
      "formConfigId"
    ],
    tag: "treasurehunting"
  },
  {
    path: ["customAttributes", "treasurehunting", "gameId"],
    tag: "treasurehunting"
  },
  {
    path: ["customAttributes", "formv4", "configStorage", "formConfigId"],
    tag: "formv4"
  },
  {
    path: ["customAttributes", "formcheckout", "configStorage", "formConfigId"],
    tag: "formcheckout"
  },
  {
    path: ["customAttributes", "leadform", "configStorage", "formConfigId"],
    tag: "leadform"
  },
  {
    path: [
      "customAttributes",
      "tempiproductlistv3",
      "productDisplay",
      "categoryId"
    ],
    tag: "tempiproductlistv3"
  },
  {
    path: ["customAttributes", "tempiproductlistv3", "productDisplay", "skus"],
    tag: "tempiproductlistv3"
  },
  {
    path: ["customAttributes", "orderpopupv2", "configStorage", "formConfigId"],
    tag: "orderpopupv2"
  }
];
const oldProductComponentTags = ["tempiproductlistv2", "tempiproductlist"];
const newProductComponentTags = ["tempiproductlistv3"];
const cartConfigPaths = [
  {
    path: ["customAttributes", "websiteheader", "desktop", "cartConfig"],
    tag: "websiteheader"
  },
  {
    path: ["customAttributes", "websiteheader", "mobile", "cartConfig"],
    tag: "websiteheader"
  },
  {
    path: ["customAttributes", "websiteheader", "orderPopupId"],
    tag: "websiteheader"
  }
];
const orderPopupTags = ["orderpopup"];
const setPbConfigProperties = (pageContent, attributes, value = null) => {
  const updateObject = (obj, path, value2) => {
    const key = path[0];
    if (path.length === 1) {
      obj[key] = value2;
    } else if (key in obj) {
      updateObject(obj[key], path.slice(1), value2);
    }
  };
  for (const key in pageContent) {
    attributes.forEach((element) => {
      if (pageContent[key].tag === element.tag) {
        updateObject(pageContent[key], element.path, value);
      }
    });
  }
};
const resetGachaGameAndFormConfig = (pageContent) => {
  setPbConfigProperties(pageContent, gachaGameAndFormPaths);
  return pageContent;
};
const removeComponentFromPbConfigById = (pageContent, id) => {
  if (!id || !pageContent[id])
    return;
  (pageContent[id].children || []).forEach(
    (childId) => removeComponentFromPbConfigById(pageContent, childId)
  );
  delete pageContent[id];
};
const removeComponentFromPbConfigByTags = (pageContent, tagsOfComponentToRemove) => {
  Object.values(pageContent).forEach((node) => {
    var _a;
    if (!tagsOfComponentToRemove.includes(node.tag)) {
      return;
    }
    removeComponentFromPbConfigById(pageContent, node == null ? void 0 : node.id);
    const parentNodeChildren = (_a = pageContent[node == null ? void 0 : node.parentId]) == null ? void 0 : _a.children;
    if (!parentNodeChildren)
      return;
    const indexOfNodeInParentChildren = parentNodeChildren.indexOf(node.id);
    if (indexOfNodeInParentChildren === -1)
      return;
    parentNodeChildren.splice(indexOfNodeInParentChildren, 1);
    pageContent[node.parentId].children = parentNodeChildren;
  });
  return pageContent;
};
var RemoveProductListType = /* @__PURE__ */ ((RemoveProductListType2) => {
  RemoveProductListType2["RemoveNewProductList"] = "removeNewProductList";
  RemoveProductListType2["RemoveOldProductList"] = "removeOldProductList";
  return RemoveProductListType2;
})(RemoveProductListType || {});
const transformPbConfigData = (pageContent, removeProductListType = "removeOldProductList" /* RemoveOldProductList */) => {
  if (!pageContent)
    return pageContent;
  resetGachaGameAndFormConfig(pageContent);
  if (removeProductListType === "removeOldProductList" /* RemoveOldProductList */) {
    removeComponentFromPbConfigByTags(pageContent, oldProductComponentTags);
  } else {
    removeComponentFromPbConfigByTags(pageContent, newProductComponentTags);
  }
  return pageContent;
};
const handlePasteSlug = (e, callback) => {
  const paste = e.clipboardData.getData("text");
  const normalizedText = paste.replace(/[–—]/g, "-");
  e.preventDefault();
  const target = e.target;
  const start = target.selectionStart || 0;
  const end = target.selectionEnd || 0;
  const currentValue = target.value;
  const newValue = currentValue.slice(0, start) + normalizedText + currentValue.slice(end);
  callback(newValue);
  setTimeout(() => {
    target.setSelectionRange(
      start + normalizedText.length,
      start + normalizedText.length
    );
  }, 0);
};



;// CONCATENATED MODULE: ../../.yarn/cache/@tempi-utils-npm-1.6.1-UX4BUYER-8801.0-f3198828ff-72bb854ccc.zip/node_modules/@tempi/utils/dist/localization.es.js
const REGIONS = {
  vi: {
    key: "vi",
    name: "Ti\u1EBFng Vi\u1EC7t"
  },
  en: {
    key: "en",
    name: "English"
  }
};
const LOCALIZATION_KEY = "localization";
const setCookie = (cname, cvalue, exMinute) => {
  if (!exMinute)
    exMinute = 30 * 24 * 60;
  const d = new Date();
  d.setTime(d.getTime() + exMinute * 60 * 1e3);
  const expires = "expires=" + d.toUTCString();
  document.cookie = `${cname}=${cvalue};${expires};path=/`;
};
const getCurrentLanguage = () => {
  var _a;
  let language;
  const urlParams = new URLSearchParams(window.location.search);
  language = urlParams.get("lang");
  if (language) {
    setCookie(LOCALIZATION_KEY, language);
    urlParams.delete("lang");
    window.history.replaceState(
      {},
      document.title,
      `${window.location.pathname}${urlParams.toString() ? `?${urlParams.toString()}` : ""}`
    );
  } else {
    const regex = new RegExp(`(^| )${LOCALIZATION_KEY}=([^;]+)`);
    const match = document.cookie.match(regex);
    if (match) {
      language = match[2];
    } else {
      const defaultLanguage = ((_a = window == null ? void 0 : window.config) == null ? void 0 : _a.defaultLanguage) || REGIONS.vi.key;
      setCookie(LOCALIZATION_KEY, defaultLanguage);
      language = defaultLanguage;
    }
  }
  return language;
};



;// CONCATENATED MODULE: ../../.yarn/cache/@tempi-utils-npm-1.6.1-UX4BUYER-8801.0-f3198828ff-72bb854ccc.zip/node_modules/@tempi/utils/dist/theme.es.js
const HEX_RADIX = 16;
const MAX_RGB_VALUE = 255;
const DEFAULT_ALPHA = 1;
const SHORTHAND_HEX_LENGTH = 3;
const FULL_HEX_LENGTH = 8;
const HEX_RED_START = 0;
const HEX_RED_END = 2;
const HEX_GREEN_START = 2;
const HEX_GREEN_END = 4;
const HEX_BLUE_START = 4;
const HEX_BLUE_END = 6;
const HEX_ALPHA_START = 6;
const HEX_ALPHA_END = 8;
const rgbToRgba = (color) => {
  return color.replace("rgb(", "rgba(").replace(")", `,${DEFAULT_ALPHA})`);
};
const normalizeRgba = (color) => {
  return color.replace(/\s+/g, "").toLowerCase();
};
const hexToRgb = (hex) => {
  hex = hex.replace("#", "");
  if (hex.length === SHORTHAND_HEX_LENGTH) {
    hex = hex.split("").map((char) => char + char).join("");
  }
  const r = parseInt(hex.substring(HEX_RED_START, HEX_RED_END), HEX_RADIX);
  const g = parseInt(hex.substring(HEX_GREEN_START, HEX_GREEN_END), HEX_RADIX);
  const b = parseInt(hex.substring(HEX_BLUE_START, HEX_BLUE_END), HEX_RADIX);
  if (hex.length === FULL_HEX_LENGTH) {
    const a = parseInt(hex.substring(HEX_ALPHA_START, HEX_ALPHA_END), HEX_RADIX) / MAX_RGB_VALUE;
    return `rgba(${r},${g},${b},${a})`;
  }
  return `rgba(${r},${g},${b},${DEFAULT_ALPHA})`;
};
const extractColors = (contentStr) => {
  const colorRegex = /(?:rgba?\([^)]+\)|#[0-9a-fA-F]{3,8})/g;
  const colorMatches = contentStr.match(colorRegex) || [];
  return colorMatches.map((color) => {
    let convertedColor = color;
    if (color.startsWith("#")) {
      convertedColor = hexToRgb(color);
    } else if (color.startsWith("rgb(")) {
      convertedColor = rgbToRgba(color);
    }
    return normalizeRgba(convertedColor);
  });
};
const getTopColorBySize = (colors, option) => {
  var _a;
  let newColor = [...colors];
  if (newColor.length < option.size && !!((_a = option.defaultColors) == null ? void 0 : _a.length)) {
    const defaultColors = option.defaultColors;
    for (let i = newColor.length; i < option.size; i++) {
      if (defaultColors[i]) {
        newColor.push({
          id: `color${i + 1}`,
          color: defaultColors[i].color
        });
      }
    }
  } else {
    newColor = colors.slice(0, option.size);
  }
  return newColor;
};
const getColorListFromContent = (contentStr) => {
  const colors = extractColors(contentStr);
  const colorCount = colors.reduce((acc, color) => {
    acc[color] = (acc[color] || 0) + 1;
    return acc;
  }, {});
  const sortedColors = Object.entries(colorCount).sort(
    ([, countA], [, countB]) => countB - countA
  ).map(([color, _], index) => ({
    id: `color${index + 1}`,
    color
  }));
  const recentColors = getTopColorBySize(sortedColors, {
    size: 40
  });
  return recentColors.map((color) => color.color);
};



;// CONCATENATED MODULE: ../../.yarn/cache/@tempi-utils-npm-1.6.1-UX4BUYER-8801.0-f3198828ff-72bb854ccc.zip/node_modules/@tempi/utils/dist/loggingPerformance.es.js
class PerformanceLogger {
  constructor() {
    this.logs = /* @__PURE__ */ new Map();
  }
  static getInstance() {
    if (!PerformanceLogger.instance) {
      PerformanceLogger.instance = new PerformanceLogger();
    }
    return PerformanceLogger.instance;
  }
  start(name) {
    var _a;
    const now = performance.now();
    if ((_a = window == null ? void 0 : window.config) == null ? void 0 : _a.enableLogPerformance) {
      console.log(`Start timing - ${name}: ${now}`);
    }
    this.logs.set(name, { startTime: now });
  }
  end(name) {
    var _a;
    const entry = this.logs.get(name);
    if (entry) {
      const now = performance.now();
      const duration = now - entry.startTime;
      if ((_a = window == null ? void 0 : window.config) == null ? void 0 : _a.enableLogPerformance) {
        console.log(`end timing - ${name}: ${now}`);
        console.log(
          `%c\u23F1\uFE0F ${name}: ${duration.toFixed(2)}ms`,
          "color: red;font-weight:bold;"
        );
      }
      this.logs.delete(name);
      return duration;
    }
    return null;
  }
  get(name) {
    const entry = this.logs.get(name);
    return entry;
  }
}
const performanceLogger = PerformanceLogger.getInstance();



;// CONCATENATED MODULE: ../../.yarn/cache/@tempi-utils-npm-1.6.1-UX4BUYER-8801.0-f3198828ff-72bb854ccc.zip/node_modules/@tempi/utils/dist/index.es.js












/***/ })

}]);